<template>
  <el-dialog
    :visible.sync="isDialogShow"
    destroy-on-close
    width="800px"
    :before-close="onClose"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="dialog-title" slot="title">上传巡查文件</div>
    <el-form v-model="form" class="form" label-width="100px">
      <el-form-item label="场站:" prop="stationId" class="form-item">
        <el-select v-model="form.stationId" class="form-item-select">
          <el-option
            v-for="station in stationList"
            :key="station.id"
            :label="station.elecName"
            :value="station.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="到场时间：" class="form-item">
        <el-date-picker
          v-model="form.locateDate"
          type="datetime"
          placeholder="选择日期时间"
          class="form-item-select"
          value-format="yyyy-MM-dd hh:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="离场时间：" class="form-item">
        <el-date-picker
          v-model="form.leaveDate"
          type="datetime"
          placeholder="选择日期时间"
          class="form-item-select"
          value-format="yyyy-MM-dd hh:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="巡查文件:"
        class="form-item"
        v-if="(form.stationId + '').length > 0"
      >
        <el-upload
          class="form-item-upload"
          ref="upload"
          drag
          accept=".jpg,.gif,.jpeg,.png,.GIF,.JPG,.PNG,.JPEG,.pdf,.PDF"
          action="/pro/upload/uploadStationCheck"
          :headers="headers"
          :show-file-list="false"
          :limit="1"
          :data="uploadParam"
          :on-success="onSuccess"
          :on-error="onError"
          :before-upload="onBeforeUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或<em>点击上传</em>，需上传图片和PDF文件
          </div>
        </el-upload>
        <div class="file-list">
          <div
            class="file-list-item"
            v-for="(item, index) in fileList"
            :key="index"
          >
            <span class="file-list-item-name">{{ item.name }}</span>
            <span class="file-list-item-size">{{ renderSize(item.size) }}</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="form-item">
        <el-button
          class="form-item-btn"
          type="primary"
          :disabled="isSubmitDisable"
          :loading="isLoading"
          @click="onSubmit"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import HTTP_STATION from "@/api/station.js";
export default {
  name: "Upload",
  props: {
    isDialogShow: {
      type: Boolean,
      require: true,
    },
    stationList: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      form: {
        stationId: "",
        locateDate: "",
        leaveDate: "",
        photoUrl: "",
        checkPdf: "",
      },
      fileList: [],
      isLoading: false,
    };
  },
  computed: {
    isSubmitDisable() {
      return (
        this.form.stationId.length === 0 ||
        this.form.locateDate.length === 0 ||
        this.form.leaveDate.length === 0
      );
    },
    headers() {
      const TOKEN_KEY = "op-token";
      return {
        "X-Token": localStorage.getItem(TOKEN_KEY),
      };
    },
    uploadParam() {
      return {
        stationId: this.form.stationId,
      };
    },
  },
  methods: {
    //  格式化文件大小
    renderSize(value) {
      if (null == value || value == "") {
        return "0 Bytes";
      }
      var unitArr = new Array(
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
      );
      var index = 0,
        srcsize = parseFloat(value);
      index = Math.floor(Math.log(srcsize) / Math.log(1024));
      var size = srcsize / Math.pow(1024, index);
      //  保留的小数位数
      size = size.toFixed(2);
      return size + unitArr[index];
    },
    //获取文件类型
    getFileType(name) {
      const list = name.split(".");
      const len = list.length;
      return list[len - 1].toString().toLowerCase();
    },
    initFileParam() {
      this.fileList.forEach((file) => {
        var type = this.getFileType(file.name);
        var imgType = ["jpg", "gif", "jpeg", "png"];
        if (imgType.includes(type)) {
          if (this.form.photoUrl.length > 0) {
            this.form.photoUrl += "," + file.url;
          } else {
            this.form.photoUrl = file.url;
          }
        } else if (type === "pdf") {
          this.form.checkPdf = file.url;
        }
      });
    },
    onClose() {
      this.$emit("onClose");
    },
    async onSubmit() {
      this.initFileParam();
      if (this.form.photoUrl.length === 0) {
        this.$message.warning("请上传图片文件");
        return;
      }
      if (this.form.checkPdf.length === 0) {
        this.$message.warning("请上传PDF文档");
        return;
      }
      try {
        this.isLoading = true;
        const res = await HTTP_STATION.addCheckInfo(this.form);
        if (res.code === 200) {
          this.$message.success("添加成功");
          setTimeout(() => {
            this.$emit("onClose");
          }, 1500);
        } else {
          this.$message.error(
            typeof res.msg === "string" ? res.msg : "请求出错，请联系管理员"
          );
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    onSuccess(response, file) {
      if (response.code === 200) {
        this.fileList.push({ url: response.data, ...file });
        this.$refs.upload.clearFiles();
      } else {
        this.$message.error(response.msg);
      }
    },
    onError() {
      this.$message.error("上传失败");
    },
    onBeforeUpload(file) {
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error("文件大小超出限制");
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog__header {
    padding: 0;
    height: 40px;
    line-height: 40px;
  }
  .el-dialog__headerbtn {
    top: 12px;
  }
  .el-dialog__body {
    padding-left: 100px;
  }
}
.dialog {
  &-title {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #777;
  }
}
.form {
  &-item {
    &-select {
      width: 360px;
    }
    &-upload {
      width: 360px;
    }
    &-btn {
      width: 360px;
    }
  }
  .file-list {
    margin: 8px;
    width: 360px;
    &-item {
      height: 40px;
      line-height: 40px;
      text-align: justify;
      &-name {
        font-weight: bold;
      }
      &-size {
        float: right;
      }
    }
  }
}
</style>
